import './i18n';
import { createRoute, redirect } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { importApiRoute } from './apiRoute';
import {
  CLAIMS, CONTAINERS, DECLS, DEPOSITS, HS_CANDIDATES, HS_FTAS, HS_PENDING, HS_RECENT, REEFERS, SHIPMENTS,
} from './fixtures';

// Màn Hàng nhập đã bỏ khỏi canvas v583: /ezy/import chuyển về Job IB; kiểu + dữ liệu mẫu giữ lại cho JobDetail IB (luồng D).
const customs: EzyModule = {
  // Menu: mục "Hàng nhập & cont" nằm trong nhóm Chứng từ & B/L (docs/module.ts) — không thêm nhóm mới.
  routes: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/import',
      beforeLoad: () => {
        throw redirect({ href: '/ezy/jobs?bound=ib' });
      },
    }),
  ],
  api: { importShipment: importApiRoute },
  fixtures: (register) => {
    register('importShipment', SHIPMENTS);
    register('importContainerFree', CONTAINERS);
    register('importDecl', DECLS);
    register('importReefer', REEFERS);
    register('importDeposit', DEPOSITS);
    register('importClaim', CLAIMS);
    register('hsCandidate', HS_CANDIDATES);
    register('hsFta', HS_FTAS);
    register('hsRecent', HS_RECENT);
    register('hsPending', HS_PENDING);
  },
};
export default customs;
